import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SideBar from '../../components/userHomeSideBar/sideBar';
import Comments from '../../components/blogDetails/comments';
import RecentPosts from '../../components/blogDetails/recentPosts';
import SocialMedia from '../../components/blogDetails/socialmedia';
import { useAuth } from '../../context/DBContext';
import {
  Layout,
  Typography,
  Form,
  Input,
  Button,
  Spin,
  Breadcrumb,
  Avatar,
  Comment,
  List,
  Divider,
  Row,
  Col,
  Affix,
  Tag,
  Card,
  Space
} from 'antd';
import {
  UserOutlined,
  TagOutlined,
  CommentOutlined,
  LoadingOutlined,
  HomeOutlined,
  EditOutlined,
  DeleteOutlined
} from '@ant-design/icons';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const BlogDetailPage = () => {
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchBlogById, addCommentToBlog, deleteBlog, currentUser, getUserInfo } = useAuth();
  const [blog, setBlog] = useState(null);
  const [newComment, setNewComment] = useState('');
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const loadBlog = async () => {
      setLoading(true);
      const fetchedBlog = await fetchBlogById(id);
      setBlog(fetchedBlog);
      setLoading(false);
    };
    loadBlog();
  }, [id, fetchBlogById]);

  useEffect(() => {
    if (currentUser) {
      getUserInfo(currentUser.uid).then((data) => {
        setUserInfo(data);
      }).catch((error) => {
        console.error('Failed to fetch user info');
      });
    }
  }, [currentUser, getUserInfo]);

  const handleCommentSubmit = async () => {
    if (!newComment.trim()) return;
    try {
      await addCommentToBlog(id, {
        author: currentUser.displayName,
        text: newComment,
        timestamp: new Date(),
      });
      setNewComment('');
    } catch (error) {
      // console.error('Error adding comment:', error);
    }
  };

  const handleEditBlog = () => {
    navigate(`/editblog/${id}`);
  };

  const handleDeleteBlog = async () => {
    if (window.confirm('Are you sure you want to delete this blog post?')) {
      try {
        await deleteBlog(id);
        navigate('/blog');
      } catch (error) {
        console.error('Failed to delete blog');
      }
    }
  };

  return (

      <Layout>
        <Content style={{ padding: '24px', backgroundColor: '#fff' }}>
          <Title
            className="site-page-header"
            title="Blog"
            subTitle="Welcome to enableSEND"
            backIcon={false}
          />
          {/* Breadcrumb (Optional) */}
          {/* <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item href="/">
              <HomeOutlined />
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/blog">Blog</Breadcrumb.Item>
            <Breadcrumb.Item>Blog Detail</Breadcrumb.Item>
          </Breadcrumb> */}
          {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            </div>
          ) : blog ? (
            <Row gutter={[24, 24]}>
              <Col xs={24} lg={16}>
                <Card
                  title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Title level={2} style={{ margin: 0 }}>{blog.title}</Title>
                      {userInfo && userInfo.role === 'admin' && (
                        <Space>
                          {/* Edit Blog    <Button
                            type="primary"
                            icon={<EditOutlined />}
                            onClick={handleEditBlog}
                          >
                            Edit
                          </Button>*/}
                        
                          <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={handleDeleteBlog}
                          >
                            Delete
                          </Button>
                        </Space>
                      )}
                    </div>
                  }
                  bordered={false}
                  style={{ marginBottom: '24px' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                    <Avatar icon={<UserOutlined />} style={{ marginRight: '8px' }} />
                    <Text strong>{blog.author}</Text>
                    <Divider type="vertical" />
                    <Tag color="blue">{blog.category}</Tag>
                    <Divider type="vertical" />
                    <CommentOutlined style={{ marginRight: '4px' }} />
                    <Text>{blog.comments.length} Comments</Text>
                  </div>
                  {blog.content.map((section, index) =>
                    section.type === 'image' ? (
                      <img
                        key={index}
                        src={section.value}
                        alt="Blog Content"
                        style={{ width: '100%', marginBottom: '16px' }}
                      />
                    ) : (
                      <div key={index}>
                        <Paragraph style={{ 
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word'
                        }}>
                          {section.value}
                        </Paragraph>
                      </div>
                    )
                  )}
                </Card>
                <Divider />
                <Title level={4}>Comments</Title>
                <Comments blogId={id} />
                <Divider />
                <Title level={4}>Leave a Reply</Title>
                <Form onFinish={handleCommentSubmit}>
                  <Form.Item>
                    <Input.TextArea
                      rows={4}
                      placeholder="Please type your comment..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Submit Comment
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
              <Col xs={24} lg={8}>
                <Affix offsetTop={80}>
                  <div>
                  <SocialMedia />
                  <div style={{ marginTop: '40px' }}>

                  <Card
                    title="Sponsored"
                    style={{ textAlign: 'center' }}
                    cover={
                      <img
                        alt="Advertisement"
                        src="/assets/advertise-here.png"
                        style={{ objectFit: 'contain', width: '100%', height: '150px' }}
                      />
                    }
                  >
                    <p>Advertise here! Contact us for more information</p>
                    <Button type="primary mt-2" href="/contact">
                      Contact Us
                    </Button>
                  </Card>
    </div>
                  </div>
                </Affix>
              </Col>
            </Row>
          ) : (
            <div style={{ textAlign: 'center', paddingTop: '100px' }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            </div>
          )}
        </Content>
      </Layout>
  );
};

export default BlogDetailPage;
